import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { UserProvider } from "./user_context";
import LandingPage from "./landing_page";
import SignIn from "./sign_in";
import SignUp from "./sign_up";
import ForgotPassword from "./forgot_password";
import VerifyEmail from "./verify_email";
import ResetPassword from "./reset-password";


//job seeker
import JobSeekerDashboard from "./portal/jobseeker/job_seeker_dashboard";
import BrowseJobs from "./portal/jobseeker/browse_jobs";
import JobDetail from "./portal/jobseeker/job_detail";
import MyApplications from "./portal/jobseeker/my_applications";
import { MyProfile } from "./portal/jobseeker/my_profile";
import { Portfolio } from "./portal/jobseeker/portfolio";
import { Messages } from "./portal/jobseeker/messages";
import { SavedJobs } from "./portal/jobseeker/saved_jobs";
import EmployerSearch from "./portal/jobseeker/search";
import EmployerDetails from "./portal/jobseeker/employer_details";

// employer
import EmployerDashboard from "./portal/employer/employer_dashboard";
import PostJob from "./portal/employer/post_job";
import MyListings from "./portal/employer/my_listings";
import { ViewApplicants } from "./portal/employer/view_applicants";
import { CandidateProfile } from "./portal/employer/candidate_profile";
import { CandidateSearchProfile } from "./portal/employer/candidate_search_profile";
import CandidateSearch from "./portal/employer/candidate_search";
import { Shortlist } from "./portal/employer/shortlist";
import { EmpMessages } from "./portal/employer/emp_messages";
import { BusinessProfile } from "./portal/employer/business_profile";
import { Analytics } from "./portal/employer/analytics";
import { JobDetailsView } from "./portal/employer/job-details";
import ProtectedRoute from "./ProtectedRoute";

export default function App() {
  return (
    <UserProvider>
    <BrowserRouter>
      <Routes>
        {/* public */}
        <Route path="/"        element={<LandingPage />} />
        <Route path="/signin"  element={<SignIn />} />
        <Route path="/signup"  element={<SignUp />} />
        <Route path="/verify"  element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* job seeker pages */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <JobSeekerDashboard />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/jobs"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <BrowseJobs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobs/:id"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <JobDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/applications"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <MyApplications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <MyProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/portfolio"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <Portfolio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <Messages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/saved-jobs"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <SavedJobs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/search"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <EmployerSearch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer-details/:id"
          element={
            <ProtectedRoute allowedRole="jobseeker">
              <EmployerDetails />
            </ProtectedRoute>
          }
        />

        {/* ── employer ── */}
        <Route
          path="/employer/dashboard"
          element={
            <ProtectedRoute allowedRole="employer">
              <EmployerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/post-job"
          element={
            <ProtectedRoute allowedRole="employer">
              <PostJob />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/listings"
          element={
            <ProtectedRoute allowedRole="employer">
              <MyListings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/listing-details/:id"
          element={
            <ProtectedRoute allowedRole="employer">
              <JobDetailsView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/applicants"
          element={
            <ProtectedRoute allowedRole="employer">
              <ViewApplicants />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/candidate-search"
          element={
            <ProtectedRoute allowedRole="employer">
              <CandidateSearch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/applicants/:listingId"
          element={
            <ProtectedRoute allowedRole="employer">
              <ViewApplicants />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/candidate/:candidateId"
          element={
            <ProtectedRoute allowedRole="employer">
              <CandidateProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/candidate-search-profile/:candidateId"
          element={
            <ProtectedRoute allowedRole="employer">
              <CandidateSearchProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/shortlist"
          element={
            <ProtectedRoute allowedRole="employer">
              <Shortlist />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/messages"
          element={
            <ProtectedRoute allowedRole="employer">
              <EmpMessages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/profile"
          element={
            <ProtectedRoute allowedRole="employer">
              <BusinessProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/analytics"
          element={
            <ProtectedRoute allowedRole="employer">
              <Analytics />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
    </UserProvider>
  );
}